import React from 'react'
import { IconMaps } from '@ow/icons'
import Icon from './Icon'
import SendCode from './SendCode'

const Content = function ({ prefix, useLoginApi }) {
  const {
    errors,
    codeBtnDisabled,
    usernameOk,
    getLoginCode,
    registerUserName,
    registerCode,
    inputOnKeyDown,
  } = useLoginApi

  return (
    <form className="w-full">
      <h1 className={`${prefix}-inputTitle`}>手机号</h1>
      <div className={`${prefix}-inputPhoneBox input-text input-${prefix}`}>
        <div>
          <IconMaps type="loginMobileIcon" width={16} height={16} fill="gray" />
          <div className="flex-1 h-4/5 flex flex-col justify-between">
            <input
              {...registerUserName()}
              autoComplete="off"
              className={`${prefix}-inputPhone phone login-input`}
              onKeyDown={inputOnKeyDown}
            />
            {errors && errors.userName && (
              <span className="text-red-1 mt-1">{errors.userName.message}</span>
            )}
          </div>
          {usernameOk && (
            <Icon
              width="15"
              color="#00aa33"
              className={`${prefix}-inputPass`}
              path="M512 1024C229.230592 1024 0 794.769408 0 512S229.230592 0 512 0s512 229.230592 512 512-229.230592 512-512 512zM254.12608 528.77312l172.396544 174.733312a0.607232 0.607232 0 0 0 0.864256 0.01536l342.540288-343.36768a0.311296 0.311296 0 0 0-0.003072-0.44032l-37.359616-37.285888a0.320512 0.320512 0 0 0-0.443392-0.02048l-304.47616 277.743616c-0.37376 0.340992-0.996352 0.357376-1.381376 0.027648L294.8608 487.48544a0.339968 0.339968 0 0 0-0.452608 0.022528l-40.27904 40.824832a0.3072 0.3072 0 0 0-0.004096 0.44032z"
            />
          )}
        </div>
      </div>

      <h1 className={`${prefix}-inputTitle`}>验证码</h1>
      <div
        className={`${prefix}-inputPwdBox input-text input-${prefix} flex justify-between`}
      >
        <div style={{ width: '60.62%' }}>
          <IconMaps
            type="loginByPasswordIcon"
            width={16}
            height={16}
            fill="gray"
          />
          <div className="w-1/2 h-4/5 flex flex-col justify-between">
            <input
              {...registerCode()}
              autoComplete="new-password"
              className={`${prefix}-inputPwd login-input pwd-${prefix}`}
              placeholder="请输入验证码"
              onKeyDown={inputOnKeyDown}
            />
            {errors && errors.code && (
              <span className="text-red-1 mt-1">{errors.code.message}</span>
            )}
          </div>
        </div>
        <SendCode
          prefix={prefix}
          disable={codeBtnDisabled}
          loginCodeApi={getLoginCode}
        />
      </div>
    </form>
  )
}
export default Content
